import { useApi, SKY_API_ENDPOINT } from '@/api';
import {
  TableSkeleton,
  formatCurrency,
  Flex,
  Card,
  DataTable,
  useTableProps,
  CryptoIcon,
  NetworkIcon
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

import { useParams } from 'react-router-dom';
export default function StarASCTable() {
  const { star } = useParams();
  const { sorting } = useTableProps({
    initialSorting: '-total_asc'
  });
  const [data, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: `/asc/primes/${star}/positions/`,
    queryParams: {
      sort: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (!data?.data?.results) {
    return <TableSkeleton rows={10} columns={6} />;
  }
  const columns: TableColumn[] = [
    {
      header: '',
      getCell: (row) => (
        <Flex alignItems="center" gap="3xs">
          <CryptoIcon
            name={row.underlying_symbol}
            address={row.underlying_address}
            network={row.network}
            size="2"
          />
          <NetworkIcon name={row.network} size="2" />
        </Flex>
      )
    },
    {
      header: 'Source',
      getCell: (row) => {
        if (row.source && row.source.includes('LITE')) {
          return 'PSM';
        }
        if (
          row.source &&
          typeof row.source === 'string' &&
          row.source.length > 0
        ) {
          return row.source.charAt(0).toUpperCase() + row.source.slice(1);
        }
        return 'ALM';
      }
    },
    {
      header: 'Type',
      getCell: (row) =>
        row.asc_type.charAt(0).toUpperCase() + row.asc_type.slice(1),
      sortingField: 'asc_type'
    },
    {
      header: 'ASC',
      getCell: (row) => formatCurrency(row.total_asc),
      sortingField: 'total_asc'
    }
  ];
  return (
    <Card>
      <DataTable
        rows={data.data.results}
        columns={columns}
        sorting={sorting}
        getKey={(row) => `${row.network}${row.address}${row.wallet_address}`}
      />
    </Card>
  );
}
